import { Component, OnInit, Input, ViewChild, SimpleChanges, forwardRef } from '@angular/core';
import { 
    IonPopover, IonDatetime,  IonLabel, IonIcon, IonButtons, IonButton 
} from '@ionic/angular/standalone';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { MarvDateToStringPipe } from '@marv/pipes';
import { MarvDateService } from '@marv/services';
import { MarvSpeechToTextComponent } from '@marv/components'; 

export class MarvInputHighlightedDate {
    date: string;
    textColor: string;
    backgroundColor: string;
    border: string;
}

@Component({
    selector: 'marv-input-date',
    templateUrl: './input-date.component.html',
    styleUrls: ['./input-date.component.scss'],
    imports: [
        IonPopover, IonDatetime, IonLabel, IonIcon, IonButtons, IonButton, TranslatePipe, ReactiveFormsModule, 
        MarvDateToStringPipe, forwardRef(() => MarvSpeechToTextComponent)
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ]
})
export class MarvInputDateComponent  implements OnInit {

    @Input({alias : 'label', required : false}) labelInput: string = '';
    @Input({alias : 'fixedLabel', required : false}) fixedLabel: boolean = false;
    @Input({alias : 'icon', required : false}) iconInput: string = 'calendar-outline';
    @Input({alias : 'formName', required : true}) formName: string|number = '';
    @Input({alias : 'errorText', required : false}) errorText: string = this.translateService.instant('MSG_ERROR_SELECT_MANDATORY');
    @Input({alias : 'disabled', required : false}) disabled: boolean = false;
    @Input({alias : 'noMargin', required : false}) noMargin: boolean = false;
    @Input({alias : 'withSpeechToText', required : false}) withSpeechToText: boolean = false;
    @Input({alias : 'minDate', required : false}) minDate: Date;
    @Input({alias : 'maxDate', required : false}) maxDate: Date;
    @Input({alias : 'isDateEnabled', required : false}) isDateEnabled: Function;
    @Input({alias : 'highlightedDates', required : false}) highlightedDates: Function|Array<MarvInputHighlightedDate>;

    @ViewChild('popoverDatetime') popoverDatetime: IonPopover;
    @ViewChild('datetime') datetime: IonDatetime;
    @ViewChild('marvSpeechToText') marvSpeechToText: MarvSpeechToTextComponent;
    
    isRequired: boolean = false;
    
    updateStatusChange: Subscription;
    
    constructor(
        public translateService: TranslateService,
        public formGroupDirective: FormGroupDirective
    ) {}

    ngOnInit() {
        this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        this.updateStatusChange = this.formGroupDirective.form.controls[this.formName].statusChanges.subscribe((s) => {
            this.isRequired = this.formGroupDirective.form.controls[this.formName].hasValidator(Validators.required);
        });
    }
    
    async ngOnChanges(changes: SimpleChanges) {                
        if(changes['disabled'] && changes['disabled'].currentValue !== null){    
            if(this.disabled === true){
                this.formGroupDirective.form.controls[this.formName].disable({emitEvent: false});
            }
            else{
                this.formGroupDirective.form.controls[this.formName].enable({emitEvent: false});
            }
        }
    }
    
    ngOnDestroy() {           
        if(this.updateStatusChange){
            this.updateStatusChange.unsubscribe();
        }
    }

    selectDate($event: any){
        if($event.detail?.value){
            this.formGroupDirective.form.controls[this.formName].setValue(new Date($event.detail.value));
            this.closeDatePicker();
        }
    }

    closeDatePicker(){
        this.popoverDatetime.dismiss();
    }
    
    speechToText($event: any){
        $event.stopPropagation();  
        if(!this.disabled){
            this.marvSpeechToText.open();
        }
    }
    
    onDismissSpeechToText(text: string){
        if(text !== '' && this.formGroupDirective.form.controls[this.formName]){
            let date = MarvDateService.ParseFromString(text);
            if(date){
                this.formGroupDirective.form.controls[this.formName].setValue(date);
            }
        }
    }
}
